import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";

interface AccordionContextType {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const AccordionContext = createContext<AccordionContextType>({
  isOpen: false,
  setIsOpen: () => {},
});

export interface AccordionProps {
  isOpen?: boolean;
  children: ReactNode | ((values: AccordionContextType) => ReactNode);
}

export function Accordion(props: AccordionProps) {
  const [isOpen, setIsOpen] = useState(Boolean(props.isOpen));

  useEffect(() => {
    setIsOpen(!!props.isOpen);
  }, [props.isOpen]);

  return (
    <AccordionContext.Provider value={{ isOpen, setIsOpen }}>
      {typeof props.children === "function"
        ? props.children({ isOpen, setIsOpen })
        : props.children}
    </AccordionContext.Provider>
  );
}
